var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuImg = function SvgMenuImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    x: 0.75,
    y: 0.75,
    stroke: "#fff",
    strokeWidth: 1.5,
    rx: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.622 10.02-3.044 4.186a.5.5 0 0 0 .404.794h13.93a.5.5 0 0 0 .38-.825l-4.894-5.71a.5.5 0 0 0-.774.018l-2.743 3.527a.5.5 0 0 1-.779.013l-1.691-2.03a.5.5 0 0 0-.789.026"
  })));
};
export default SvgMenuImg;